import { ref } from 'vue'

const message = ref('')
const visible = ref(false)
let hideTimer: ReturnType<typeof setTimeout> | undefined

export function useDashboardToast() {
  const showToast = (msg: string) => {
    message.value = msg
    visible.value = true
    if (hideTimer) clearTimeout(hideTimer)
    hideTimer = setTimeout(() => {
      visible.value = false
    }, 2800)
  }

  return {
    message,
    visible,
    showToast,
  }
}
